module.exports = __webpack_public_path__ + "img/history.b09d556a.svg";